import { render, staticRenderFns } from "./signature-holder.vue?vue&type=template&id=1f2094e9"
import script from "./signature-holder.vue?vue&type=script&lang=js"
export * from "./signature-holder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports